/**
 * Tuition Calculator
 * -----------------------------------------------------------------------------
 * 
 * Notes
 * 1. `tuition_calculator` is a Module ID used by the build and will point to
 *    the Tuition Table script once the main JS file is bundled.
 */

// Imports
const { ALERT_MESSAGES } = require( '../utilities/_constants' );



const isTuitionCalculatorPage = document.querySelector( '.tuition-calc' );

if ( isTuitionCalculatorPage ) {

  try {

    /* 1 */
    import( 'tuition_calculator' )
      .catch( ( e ) => console.log( e ) );

  } catch( e ) {
    alert( ALERT_MESSAGES.DYNAMIC_IMPORTS );
  }

}
